import { Alert, Box, Snackbar, Typography } from "@mui/material";
import FormHeader from "../../dms_common/FormHeader";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import LoadoutFilter from "../common/LoadoutFilter";
import CreateSummaryCard from "../common/CreateSummaryCard";
import ReactSwitch from "react-switch";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { presellerColumnsMetaData } from "./PresellerUtils";
import { DownloadSingleReportConfig, popupType } from "../../../types/types";
import CustomDataGrid from "../../dms_common/CustomDataGrid";
import { Loader } from "../../loader/Loader";
import { getLocalTimeDate } from "../../../services/manageOrderService";
import dayjs, { Dayjs } from "dayjs";
import {
  ApiResponse,
  ApiStatus,
  DataDisplayPreference,
  DropdownData,
  GenericModal,
  InvoicesCount,
  loadoutCartState,
  loadoutsSalesData,
  VehicleOption,
} from "../common/types";
import { GenericPopUp } from "../../popup/genericPopUp";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {
  fetchLoadoutConfigs,
  getAllDeliveryRouteFromRouteInfo,
  getAllowedStatuses,
  getAllSalesMans,
  getAllSalesReps,
  getAllVehicleData,
  getDataBasedOnToggle,
  getOrderAndInvoiceData,
  getRouteOutletMap,
  globalOutletRouteMap,
  onInvoiceDownLoad,
  populateCart,
  printLoadslip,
  searchedData,
  setLoadoutConfig,
} from "./PresellerLoadoutService";
import {
  getDataFromLocalDb,
  insertDataIntoLocalDB,
} from "../../../services/dbService";
import {
  deleteLoadout,
  getSingleLoadout,
  updateLoadout,
} from "../../../services/loadoutService";
import { getConfigData } from "../../../services/configurationService";
import { getDownloadSingleReportConfig } from "../../../features/secondaryOrder/ManageSecondaryOrderUtils";
import selectOptionFirst from "../../../assets/image/svg/loadoutSelectOption.svg";
import {
  getGenericModalProps,
  initialGenericModalProps,
} from "../LoadoutUtils";
import CustomGenericModal from "../../dms_common/CustomGenericModal";
import { PerformanceTrace, trace } from "firebase/performance";
import {
  logAnalyticsEvent,
  logLoadTrace,
  performance,
} from "../../../firebase";
import { truncateToTwoDecimals } from "../../dms_common/DmsUtils";
import LoadoutCartSummaryFooter from "../common/LoadoutCartSummaryFooter";
import { initialLoadoutConfigState } from "../../../stateManagement/reducers/presellerLoadout";

const dummyVehicleOption = {
  vehicleId: "",
  vehicleNumber: "",
  vehicleType: "",
  vehicleCapacityKG: 0,
  vehicleCapacityCubicFeet: 0,
};

export default function PresellerDelivery() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location: any = useLocation();

  const { loadNumber } = useParams();
  const cart: loadoutCartState = useSelector(
    (state: any) => state.presellerLoadoutState
  );

  const [fetchedLoadNumberWiseData, setFetchedLoadNumberWiseData] =
    useState<boolean>(false);
  const [genericModalProps, setGenericModalProps] = useState<GenericModal>(
    initialGenericModalProps
  );
  const [openGenericModal, setOpenGenericModal] = useState<boolean>(false);
  const [popupType, setPopupType] = useState<popupType>("Alert");
  const [genericMessage, setGenericMessage] = useState<string>("");
  const [deliveryStartDate, setDeliveryStartDate] = useState<Dayjs | null>(
    null
  );
  const [deliveryEndDate, setDeliveryEndDate] = useState<Dayjs | null>(null);
  const [checkedIdArray, setCheckedIdArray] = useState<string[]>([]);
  const [invoicesCount, setInvoicesCount] = useState<InvoicesCount>({
    valid: 0,
    invalid: [],
  });
  const [loadoutResponse, setLoadoutResponse] = useState<any>(null);
  const [selectableRowIds, setSelectableRowIds] = useState<string[]>([]);
  const [showPopup, setShowPopup] = useState<boolean>(false);
  const [selectedCheckboxes, setSelectedCheckboxes] = useState<number[]>([]);
  const [errorMessageText, setErrorMessageText] = useState<string>("");
  const [loader, setLoader] = useState(true);
  const [delayedLoading, setDelayedLoading] = useState(true);
  const [isCartDataLoaded, setIsCartDataLoaded] = useState<Boolean>(false);
  const [downloadSingleReportConfig, setDownloadSingleReportConfig] =
    useState<DownloadSingleReportConfig | null>();
  const [currentData, setCurrentData] = useState<loadoutsSalesData[]>([]);
  const [combinedData, setCombinedData] = useState<loadoutsSalesData[]>([]);
  const [rows, setRows] = useState<loadoutsSalesData[]>([]);
  const [allProducts, setAllProducts] = useState<any>([]);
  const [dropdownData, setDropdownData] = useState<DropdownData>({
    allDeliveryRoutes: [],
    allSalesRepOrRoute: [],
    allSalesmans: [],
    allVehicles: [],
  });
  const [apiStatus, setApiStatus] = useState<ApiStatus>({
    orderStatus: true,
    invoiceStatus: true,
  });
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [isConfigLoaded, setIsConfigLoaded] = useState<boolean>(false);
  const [columnsMetaData, setColumnsMetaData] = useState<any>(
    cart?.loadoutConfig?.presellerColumnsConfig || presellerColumnsMetaData
  );
  const [searchVal, setSearchVal] = useState<string>("");
  const [selectedSalesman, setSelectedSalesman] = useState<string>("");
  const [selectedVehicle, setSelectedVehicle] = useState<
    VehicleOption | undefined
  >(undefined);
  const [selectedRoute, setSelectedRoute] = useState<string[]>([]);
  const [deliveryRouteToSalesmanCodeMap, setDeliveryRouteToSalesmanCodeMap] =
    useState<{ isLoaded: boolean; data: Map<string, string[]> }>({
      isLoaded: false,
      data: new Map(),
    });
  const [salesRepDropdownDataRouteWise, setSalesRepDropdownDataRouteWise] =
    useState<{ isLoaded: boolean; data: string[] }>({
      isLoaded: false,
      data: [],
    });
  const previousSelectedVehicleRef = useRef<VehicleOption | undefined>(
    undefined
  );
  const pageLoadTraceRef = useRef<PerformanceTrace | null>(null);
  const [consumedVehicleCapacity, setConsumedVehicleCapacity] = useState<
    VehicleOption | undefined
  >(undefined);
  const [selectedSalesrepOrRoute, setSelectedSalesrepOrRoute] = useState<
    string[]
  >([]);
  const previousCheckedIdsRef = useRef<Set<string>>(new Set());
  const [isFetchDataComplete, setIsFetchDataComplete] = useState({
    fetchedCombinedData: false,
    fetchedCurrentData: false,
  });

  const [isDownloading, setIsDownloading] = useState<boolean>(false);
  const [loadoutStatus, setLoadoutStatus] = useState<string>("");
  const [invoiceNumbersSet, setInvoiceNumbersSet] = useState<Set<string>>(
    new Set()
  );
  const [outletRouteMap, setOutletRouteMap] = useState<Map<string, string[]>>(
    new Map()
  );
  const [hasInitialMatchingDone, setHasInitialMatchingDone] =
    useState<boolean>(false);
  const [shouldFilterCheckedIds, setShouldFilterCheckedIds] =
    useState<boolean>(false);

  const dateChangeHandler = (
    updatedStartDate: Dayjs | null,
    updatedEndDate: Dayjs | null
  ) => {
    let dateChanged = false;

    if (
      updatedStartDate &&
      !updatedStartDate.isSame(deliveryStartDate, "day")
    ) {
      setDeliveryStartDate(updatedStartDate);
      dispatch({
        type: "SET_LOADOUT",
        payload: { deliveryStartDate: updatedStartDate },
      });
      dateChanged = true;
    }

    if (updatedEndDate && !updatedEndDate.isSame(deliveryEndDate, "day")) {
      setDeliveryEndDate(updatedEndDate);
      dispatch({
        type: "SET_LOADOUT",
        payload: { deliveryEndDate: updatedEndDate },
      });
      dateChanged = true;
    }

    if (dateChanged && checkedIdArray.length > 0) {
      setShouldFilterCheckedIds(true);
    }

    if (updatedStartDate || updatedEndDate) {
      logAnalyticsEvent("delivery_loadout_preseller_delivery_date_filter", {
        distributor_id: JSON.parse(localStorage.authContext).user.loginId,
        delivery_start_date_selected: updatedStartDate,
        delivery_end_date_selected: updatedStartDate,
      });
    }
  };

  const handleSnackbarClose = (
    _event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  const fetchData = useCallback(
    async (
      startDate: Dayjs | null,
      endDate: Dayjs | null,
      dataDisplayPreference: DataDisplayPreference[],
      loadoutStatus: String | null,
      switchState: boolean,
      loadoutResponse: any,
      setOfInvoiceNumbers: Set<string>,
      salesRepData: string[]
    ) => {
      const start = startDate ? getLocalTimeDate(startDate, "start") : null;
      const end = endDate ? getLocalTimeDate(endDate, "end") : null;

      if (start && end) {
        await getAllData(
          start,
          end,
          dataDisplayPreference,
          loadoutStatus ?? "",
          switchState,
          loadoutResponse,
          setOfInvoiceNumbers,
          salesRepData
        );
      }
    },
    [loadNumber, fetchedLoadNumberWiseData, cart?.loadoutConfig]
  );

  const fetchConfigs = useCallback(async () => {
    if (isConfigLoaded) return;
    try {
      setLoader(true);
      if (
        JSON.stringify(cart?.loadoutConfig) ===
        JSON.stringify(initialLoadoutConfigState)
      ) {
        const loadoutConfigValue = await fetchLoadoutConfigs("loadoutConfigs");
        // Assuming fetchLoadoutConfigs returns an object with presellerColumnsConfig
        setLoadoutConfig(
          {
            ...loadoutConfigValue,
            presellerColumnsConfig:
              loadoutConfigValue.presellerColumnsConfig ||
              presellerColumnsMetaData, // Fallback to default if not provided
          },
          dispatch
        );
      }
      setIsConfigLoaded(true);
    } catch (error) {
      setGenericModalProps(
        getGenericModalProps("error", "Failed to fetch loadout configurations.")
      );
      setIsConfigLoaded(false);
    } finally {
      setLoader(false);
    }
  }, [isConfigLoaded, dispatch]);

  const fetchCartData = useCallback(
    async (loadoutResponse: any) => {
      if (
        !isConfigLoaded ||
        JSON.stringify(cart?.loadoutConfig) ===
          JSON.stringify(initialLoadoutConfigState)
      ) {
        return;
      }

      if (
        (cart?.loadoutConfig?.maxDeliveryDateOffset ?? 0) < 0 ||
        (cart?.loadoutConfig?.maxDeliveryDateOffset ?? 0) > 183 ||
        (cart?.loadoutConfig?.minDeliveryDateOffset ?? 0) < 0 ||
        (cart?.loadoutConfig?.minDeliveryDateOffset ?? 0) > 183
      ) {
        openPopUp(
          `Invalid Configuration: The MaxDeliveryDateOffset and MinDeliveryDateOffset values must be between 0 and 183 days (6 months). Current values: MaxDeliveryDateOffset: ${cart?.loadoutConfig?.maxDeliveryDateOffset}, MinDeliveryDateOffset: ${cart?.loadoutConfig?.minDeliveryDateOffset}. Please update the configuration to a valid range.`,
          "Error"
        );
        return;
      } else if (cart?.loadoutConfig?.gapBetweenCreationAndDeliveryDate < 0) {
        openPopUp(
          "Gap Between Creation and Delivery Date must be greater than 0.",
          "Error"
        );
        return;
      }

      const validTypes = ["order", "invoice"];
      const invalidTypes = cart?.loadoutConfig?.dataDisplayPreference?.filter(
        (preference: { type: string }) => !validTypes.includes(preference.type)
      );

      if (
        (invalidTypes ?? []).length > 0 ||
        !cart?.loadoutConfig?.dataDisplayPreference
      ) {
        openPopUp(
          "Please provide a valid DataDisplayPreference in loadout_configuration: 'order' or 'invoice'.",
          "Error"
        );
      }

      if (
        cart?.loadoutConfig?.dataDisplayPreference?.some(
          (preference: { type: string; visible: boolean }) =>
            preference.type === "invoice" && preference.visible
        ) &&
        cart?.loadoutConfig?.dataDisplayPreference?.some(
          (preference: { type: string; visible: boolean }) =>
            preference.type === "order" && !preference.visible
        )
      ) {
        dispatch({ type: "SET_SWITCH_STATE", payload: true });
      }

      const res = await getDataFromLocalDb("Cart");
      const savedCart = await JSON.parse(
        JSON.stringify(res?.data?.[0]?.data ?? {})
      );

      let switchState = false;
      if (Object.keys(savedCart?.cartData?.loadout ?? {})?.length) {
        switchState = savedCart?.cartDate?.switchState;
        dispatch({ type: "SET_PRESELLER_LOADOUT", payload: savedCart });
        setSelectedSalesman(savedCart?.cartData?.loadout?.SalesMan || "");
        setSelectedSalesrepOrRoute(
          savedCart?.cartData?.loadout?.salesRepOrRoute || []
        );
        setSelectedRoute(savedCart?.cartData?.loadout?.selectedRoute || []);
        setSelectedVehicle(savedCart?.cartData?.loadout?.Vehicle || undefined);
        setConsumedVehicleCapacity(
          savedCart?.cartData?.loadout?.consumedVehicleCapacity || undefined
        );

        if (savedCart?.cartData?.loadout?.deliveryStartDate?.$d) {
          setDeliveryStartDate(
            dayjs(
              savedCart?.cartData?.loadout?.deliveryStartDate?.$d || undefined
            )
          );
        }

        if (savedCart?.cartData?.loadout?.deliveryEndDate?.$d) {
          setDeliveryEndDate(
            dayjs(
              savedCart?.cartData?.loadout?.deliveryEndDate?.$d || undefined
            )
          );
        }

        setCheckedIdArray(
          savedCart?.cartData?.salesData.map(
            (item: loadoutsSalesData) => item.id
          ) || []
        );
        setIsCartDataLoaded(true);
      }
      // Call all three API calls in parallel, but only if their respective conditions are met.
      const apiPromises: Promise<any>[] = [];

      // Salesman API
      if (cart?.loadoutConfig?.enableSalesmanAssignment) {
        const salesmanPromise = (async () => {
          let salesmans: ApiResponse = { apiStatus: false, data: [] };
          await logLoadTrace(async () => {
            salesmans = await getAllSalesMans(
              cart?.loadoutConfig?.salesmanDesignations || []
            );
          }, "delivery_loadout_preseller_salesman_load_time");

          if (!salesmans.apiStatus) {
            setGenericModalProps(
              getGenericModalProps("error", "Failed to retrieve salesman data.")
            );
          }
          setDropdownData((prev) => ({
            ...prev,
            allSalesmans: salesmans.data,
          }));
        })();
        apiPromises.push(salesmanPromise);
      }

      let salesRepData: string[] = [];
      if (!loadNumber) {
        const salesRepPromise = logLoadTrace(async () => {
          salesRepData = await setSalesRepDropdownData();
        }, "delivery_loadout_preseller_salesrep_or_delivery_route_load_time");
        apiPromises.push(salesRepPromise);
      }

      if (cart?.loadoutConfig?.enableDeliveryRouteFilter) {
        const deliveryRoutePromise = (async () => {
          const deliveryRouteData = await getAllDeliveryRouteFromRouteInfo(
            true
          );
          setDropdownData((prev) => ({
            ...prev,
            allDeliveryRoutes: deliveryRouteData.data,
          }));
          setDeliveryRouteToSalesmanCodeMap({
            isLoaded: true,
            data: deliveryRouteData.deliveryRouteToSalesmanCodeMap,
          });
        })();
        apiPromises.push(deliveryRoutePromise);
      }

      // Vehicle API
      if (cart?.loadoutConfig?.enableVehicleAssignment) {
        console.log("fetching vehicle data", loadoutResponse?.vehicleId);
        const vehiclePromise = (async () => {
          let vehicles: ApiResponse = { apiStatus: false, data: [] };
          await logLoadTrace(async () => {
            if (
              (loadoutResponse?.status === "IN-TRANSIT" ||
                loadoutResponse?.status === "DELIVERED") &&
              !loadoutResponse?.vehicleId
            ) {
              vehicles = { apiStatus: true, data: [] };
            } else {
              vehicles = await getAllVehicleData(
                loadoutResponse?.vehicleId &&
                  loadoutResponse?.status !== "IN-DRAFT"
                  ? loadoutResponse?.vehicleId
                  : ""
              );
            }
          }, "delivery_loadout_preseller_vehicle_load_time");
          if (!vehicles.apiStatus) {
            setGenericModalProps(
              getGenericModalProps("error", "Failed to retrieve vehicle data.")
            );
          }
          setDropdownData((prev) => ({
            ...prev,
            allVehicles: vehicles.data,
          }));
          if (loadNumber) {
            setSelectedVehicle(
              vehicles.data.find(
                (vehicle) => vehicle.vehicleId === loadoutResponse?.vehicleId
              )
            );
          }
        })();
        apiPromises.push(vehiclePromise);
      }

      // Wait for all API calls to finish
      if (apiPromises.length > 0) {
        await Promise.all(apiPromises);
      }

      const dbResult = await getDataFromLocalDb("Product");
      const products: any = dbResult?.data?.[0]?.data ?? {};
      setAllProducts(products);

      if (!loadNumber) {
        const startDate = dayjs().subtract(
          cart?.loadoutConfig?.minDeliveryDateOffset ?? 0,
          "days"
        );
        const endDate = dayjs().add(
          cart?.loadoutConfig?.maxDeliveryDateOffset ?? 0,
          "days"
        );

        await fetchData(
          startDate,
          endDate,
          cart?.loadoutConfig?.dataDisplayPreference,
          null,
          switchState,
          null,
          new Set<string>(),
          salesRepData
        );
        setIsFetchDataComplete({
          fetchedCombinedData: true,
          fetchedCurrentData: false,
        });
      }
    },
    [isConfigLoaded, cart?.loadoutConfig]
  );

  const setSalesRepDropdownData = async () => {
    const salesrepsOrRoute = cart?.loadoutConfig?.presellerRouteMaintained
      ? await getAllDeliveryRouteFromRouteInfo()
      : await getAllSalesReps(cart?.loadoutConfig?.salesrepDesignations || []);

    if (!salesrepsOrRoute.apiStatus) {
      setGenericModalProps(
        getGenericModalProps(
          "error",
          cart?.loadoutConfig?.presellerRouteMaintained
            ? "Failed to retrieve delivery routes data."
            : "Failed to retrieve salesrep data."
        )
      );
    }
    if (cart?.loadoutConfig?.enableDeliveryRouteFilter) {
      setSalesRepDropdownDataRouteWise({
        isLoaded: true,
        data: salesrepsOrRoute.data,
      });
    } else {
      setDropdownData((prev) => ({
        ...prev,
        allSalesRepOrRoute: salesrepsOrRoute.data,
      }));
    }

    return salesrepsOrRoute.data;
  };

  const getMatchingRouteOptions = () => {
    if (!loadoutResponse?.loadOutDetails) return [];

    const uniqueRouteCodes = Array.from(
      new Set(
        loadoutResponse.loadOutDetails
          .map((item: any) => item.routeCode)
          .filter((item: any) => item !== null && item !== "")
      )
    ).filter((item): item is string => typeof item === "string");

    return uniqueRouteCodes
      .map((routeCode) => {
        return dropdownData.allDeliveryRoutes.find((option) =>
          option.startsWith(`${routeCode} - `)
        );
      })
      .filter((option): option is string => option !== undefined);
  };

  const updateSelectedRouteFromLoadoutDetails = () => {
    if (dropdownData.allDeliveryRoutes.length > 0) {
      const matchingDropdownOptions = getMatchingRouteOptions();
      if (matchingDropdownOptions.length > 0) {
        setSelectedRoute(matchingDropdownOptions);
      }
    }
  };

  const updateRowsAndColumns = (
    dataToUpdate = combinedData,
    switchState: boolean,
    loadoutStatus: string
  ) => {
    setConsumedVehicleCapacity(
      cart?.cartData?.loadout?.consumedVehicleCapacity
    );
    if (isFetchDataComplete.fetchedCurrentData && !loadNumber)
      setCheckedIdArray([]);
    const invoiceStatuses = getAllowedStatuses(
      loadoutStatus,
      cart?.loadoutConfig?.allowedStatuses
    );

    const { updatedColumnsMetaData, filteredData } = getDataBasedOnToggle(
      switchState,
      dataToUpdate,
      invoiceStatuses,
      loadoutStatus ?? "",
      invoiceNumbersSet,
      cart?.loadoutConfig?.invoiceActions,
      cart?.loadoutConfig?.orderActions,
      setInvoicesCount,
      cart?.loadoutConfig?.presellerColumnsConfig || presellerColumnsMetaData
    );

    setColumnsMetaData(updatedColumnsMetaData);
    setCurrentData(filteredData);
    setRows(filteredData);

    if (loadNumber) {
      if (
        loadoutStatus.length > 0 &&
        loadoutStatus !== "IN-DRAFT" &&
        cart?.loadoutConfig?.enableDeliveryRouteFilter
      ) {
        const selectedRouteOptions = getMatchingRouteOptions();
        if (selectedRouteOptions.length > 0) {
          setDropdownData((prev) => ({
            ...prev,
            allDeliveryRoutes: selectedRouteOptions,
          }));
        }
      }

      if (loadoutStatus === "IN-DRAFT") {
        if (selectedRoute.length === 0 && !isCartDataLoaded) {
          updateSelectedRouteFromLoadoutDetails();
        }
      } else {
        updateSelectedRouteFromLoadoutDetails();
      }

      const matchedIds = filteredData
        .filter((data: loadoutsSalesData) =>
          invoiceNumbersSet.has(
            cart?.switchState
              ? data.invoiceNumber ?? ""
              : data.orderNumber ?? ""
          )
        )
        .map((data) => data.id);

      if (!isCartDataLoaded) {
        setCheckedIdArray(matchedIds);
      }
    }

    if (isFetchDataComplete.fetchedCombinedData) {
      setIsFetchDataComplete({
        fetchedCombinedData: true,
        fetchedCurrentData: true,
      });
    }
  };

  const openPopUp = useCallback((message: string, type: popupType) => {
    setPopupType(type);
    setGenericMessage(message);
    setOpenGenericModal(true);
  }, []);

  const getAllData = useCallback(
    async (
      startDate: string,
      endDate: string,
      dataDisplayPreference: DataDisplayPreference[],
      loadoutStatus: String | null,
      switchState: boolean,
      loadoutResponse: any,
      setOfInvoiceNumbers: Set<string>,
      salesRepData: string[]
    ) => {
      try {
        setLoader(true);
        setCombinedData([]);

        const invoiceStatuses = getAllowedStatuses(
          loadoutStatus,
          cart?.loadoutConfig?.allowedStatuses
        );
        const orderStatuses = getAllowedStatuses(
          loadoutStatus,
          cart?.loadoutConfig?.allowedStatuses
        );

        let currCombinedData, orderStatus, invoiceStatus;

        if (
          loadNumber &&
          Object.keys(cart?.cartData?.salesData).length > 0 &&
          loadoutStatus !== "IN-DRAFT"
        ) {
          currCombinedData = cart.cartData.salesData;
          orderStatus = true;
          invoiceStatus = true;
        } else {
          const result = await getOrderAndInvoiceData(
            startDate,
            endDate,
            dataDisplayPreference,
            invoiceStatuses,
            orderStatuses,
            loadNumber,
            switchState,
            loadoutStatus ?? "",
            cart?.loadoutConfig,
            loadoutResponse,
            setOfInvoiceNumbers,
            salesRepData
          );
          currCombinedData = result.currCombinedData;
          orderStatus = result.orderStatus;
          invoiceStatus = result.invoiceStatus;
          if (cart?.loadoutConfig?.presellerRouteMaintained) {
            const outletRouteMapResult = await getRouteOutletMap(
              result.outletCodesSet,
              setSnackbarMessage,
              setSnackbarOpen
            );
            setOutletRouteMap(outletRouteMapResult);
            result.currCombinedData.forEach((item: any) => {
              item.salesRoute = globalOutletRouteMap.get(item.outletCode) || "";
            });
          }
        }

        setCombinedData(currCombinedData);
        setApiStatus({
          orderStatus,
          invoiceStatus,
        });
      } catch (error) {
        setRows([]);
        setCurrentData([]);
        setCombinedData([]);
        openPopUp("Something went wrong", "Error");
      } finally {
        setLoader(false);
      }
    },
    [cart?.loadoutConfig?.presellerRouteMaintained, invoiceNumbersSet]
  );

  const updateCheckedIds = useCallback(async () => {
    const currentCheckedIds = new Set<string>(
      checkedIdArray.map((row) => row.trim())
    );

    if (
      (cart?.totals?.totalAmount ?? 0) > 0 &&
      previousCheckedIdsRef.current.size === 0
    ) {
      previousCheckedIdsRef.current = currentCheckedIds;
      return;
    }

    if (checkedIdArray.length === 0) {
      dispatch({ type: "RESET_CART_DATA" });
      previousCheckedIdsRef.current = new Set<string>();
      setConsumedVehicleCapacity(undefined);
      return;
    }

    const previousCheckedIds = previousCheckedIdsRef.current;
    let updatedProduct = { ...cart?.cartData?.product };
    const updatedVehicleCapacity = {
      cubicFeet: consumedVehicleCapacity?.vehicleCapacityCubicFeet ?? 0,
      KG: consumedVehicleCapacity?.vehicleCapacityKG ?? 0,
    };

    const wasVehicleJustAssigned =
      (cart?.loadoutConfig?.enableVehicleAssignment &&
        previousSelectedVehicleRef.current === undefined &&
        selectedVehicle !== undefined) ||
      selectedVehicle === undefined ||
      previousCheckedIds.size === 0;

    checkedIdArray.forEach(async (row: string) => {
      if (!previousCheckedIds.has(row.trim()) || !wasVehicleJustAssigned) {
        const orderData = currentData.find((order) => order.id === row);
        if (orderData) {
          await populateCart(
            orderData,
            updatedProduct,
            cart?.switchState,
            dispatch,
            allProducts,
            cart?.totals,
            true,
            setSnackbarMessage,
            setSnackbarOpen,
            cart?.loadoutConfig?.enableVehicleAssignment &&
              Boolean(selectedVehicle),
            cart?.loadoutConfig?.vehicleUOMKeys,
            updatedVehicleCapacity,
            wasVehicleJustAssigned ?? false,
            cart?.loadoutConfig?.displayVehicleCapacityValidationErrorMessage,
            cart?.loadoutConfig?.batchIdConfiguration,
            loadoutStatus
          );
        }
      }
    });

    previousCheckedIds.forEach(async (row: string) => {
      if (!currentCheckedIds.has(row)) {
        const orderData = currentData.find((order) => order.id === row);
        if (orderData) {
          await populateCart(
            orderData,
            updatedProduct,
            cart?.switchState,
            dispatch,
            allProducts,
            cart?.totals,
            false,
            setSnackbarMessage,
            setSnackbarOpen,
            cart?.loadoutConfig.enableVehicleAssignment &&
              Boolean(selectedVehicle),
            cart?.loadoutConfig?.vehicleUOMKeys,
            updatedVehicleCapacity,
            wasVehicleJustAssigned ?? false,
            cart?.loadoutConfig?.displayVehicleCapacityValidationErrorMessage,
            cart?.loadoutConfig?.batchIdConfiguration,
            loadoutStatus
          );
        }
      }
    });

    previousCheckedIdsRef.current = currentCheckedIds;
    previousSelectedVehicleRef.current = selectedVehicle ?? {
      id: "",
      vehicleNumber: "",
      vehicleType: "",
      vehicleCapacityKG: 0,
      vehicleCapacityCubicFeet: 0,
    };

    setConsumedVehicleCapacity((prev) => {
      const updatedCapacity = {
        ...prev,
        vehicleCapacityCubicFeet: parseFloat(
          truncateToTwoDecimals(updatedVehicleCapacity?.cubicFeet)
        ),
        vehicleCapacityKG: parseFloat(
          truncateToTwoDecimals(updatedVehicleCapacity?.KG)
        ),
      };
      dispatch({
        type: "SET_LOADOUT",
        payload: { consumedVehicleCapacity: updatedCapacity },
      });
      return updatedCapacity;
    });

    dispatch({
      type: "SET_SALES_DATA",
      payload: currentData.filter((row) => checkedIdArray.includes(row.id)),
    });
  }, [checkedIdArray, currentData, cart?.switchState, selectedVehicle]);

  const handleReviewLoadout = async () => {
    navigate("review", {
      state: {
        selectedVehicle: selectedVehicle,
        consumedVehicleCapacity,
        loadoutStatus,
      },
    });
    await insertDataIntoLocalDB("Cart", [
      {
        id: 1,
        data: {
          ...cart,
          cartData: {
            ...cart.cartData,
            loadout: {
              ...cart.cartData.loadout,
              salesRepOrRoute: selectedSalesrepOrRoute,
              selectedRoute: selectedRoute,
            },
          },
        },
      },
    ]);
  };

  const updateCheckedIdArray = (selectedIds: any[]) => {
    const invariantIds = checkedIdArray.filter(
      (checkedId) => !selectableRowIds.includes(checkedId)
    );
    let updatedCheckedIdArray = Array.from(
      new Set([...invariantIds, ...selectedIds])
    );

    if (
      updatedCheckedIdArray.length >
      cart?.loadoutConfig?.maxInvoiceSelectionLimit
    ) {
      updatedCheckedIdArray = updatedCheckedIdArray.slice(
        0,
        cart?.loadoutConfig?.maxInvoiceSelectionLimit
      );
      setSnackbarMessage(
        `Limit reached: You can select up to  ${cart?.loadoutConfig?.maxInvoiceSelectionLimit} invoices for one loadout.`
      );
      setSnackbarOpen(true);
    } else {
      setSnackbarOpen(false);
    }
    setCheckedIdArray(updatedCheckedIdArray);
  };

  const updateCurrentLoadout = async () => {
    if (!loadoutResponse || !loadoutResponse?.loadOutDetails) return;

    // Filter out the loadOutDetails that are not in the invalid invoices list
    const updatedLoadOutDetails = loadoutResponse.loadOutDetails.filter(
      (detail: any) => !invoicesCount.invalid.includes(detail.invoiceNumber)
    );

    // Update the loadoutResponse with the filtered loadOutDetails
    const updatedLoadoutResponse = {
      ...loadoutResponse,
      loadOutDetails: updatedLoadOutDetails,
    };

    try {
      setLoader(true);
      const response = await updateLoadout(updatedLoadoutResponse);
      dispatch({ type: "SET_LOADOUT_DATA", payload: response?.data });
      setGenericModalProps(initialGenericModalProps);
    } catch (error) {
      console.error("Failed to update loadout", error);
      openPopUp("Failed to update loadout. Please try again.", "Error");
    } finally {
      setLoader(false);
    }
  };

  const confirmDelete = async (
    loadNumberToDelete: string = loadNumber ?? ""
  ) => {
    if (!loadNumberToDelete) return;

    try {
      setLoader(true);
      await deleteLoadout(loadNumberToDelete);

      navigate("/dashboard/delivery/loadouts");
    } catch (error) {
      setGenericModalProps(
        getGenericModalProps(
          "error",
          "Failed to delete loadout. Please try again."
        )
      );
    } finally {
      setLoader(false);
    }
  };

  const handleDelete = async () => {
    setGenericModalProps({
      type: "negative",
      message: `Are you sure you want to delete loadout ${loadNumber}?`,
      leftButtonText: "Delete",
      rightButtonText: "Cancel",
      open: true,
      onLeftButtonClick: () => confirmDelete(loadNumber ?? ""),
      onRightButtonClick: () => setGenericModalProps(initialGenericModalProps),
    });
  };

  useEffect(() => {
    fetchConfigs();
  }, []);

  useEffect(() => {
    // Only proceed with other data fetching after configurations are loaded
    if (!isConfigLoaded || isCartDataLoaded || (loadNumber && !loadoutResponse))
      return;

    const executeFetchConfigsAndCartData = async () => {
      if (loadNumber && loadoutResponse) {
        pageLoadTraceRef.current = trace(
          performance,
          "delivery_loadout_view_or_edit_page_load_time"
        );

        pageLoadTraceRef.current.start();
        await fetchCartData(loadoutResponse);
      } else if (!loadNumber) {
        await logLoadTrace(
          () => fetchCartData(loadoutResponse),
          "delivery_loadout_preseller_create_page_load_time"
        );
      }
    };
    executeFetchConfigsAndCartData();
  }, [
    loadNumber,
    isConfigLoaded,
    cart?.loadoutConfig,
    isCartDataLoaded,
    loadoutResponse,
  ]);

  useEffect(() => {
    if (invoicesCount.invalid.length > 0 && invoicesCount.valid > 0) {
      if (invoicesCount.invalid.length === invoicesCount.valid) {
        setGenericModalProps({
          type: "negative",
          message: `All ${
            cart?.switchState ? "invoices" : "orders"
          } are present in the existing loadout. Do you want to delete the loadout`,
          leftButtonText: "Yes",
          rightButtonText: "No",
          open: true,
          onLeftButtonClick: () => confirmDelete(loadNumber ?? ""),
          onRightButtonClick: () => navigate("/dashboard/delivery/loadouts"),
        });
      } else {
        const itemType = cart?.switchState
          ? invoicesCount.invalid.length === 1
            ? "invoice"
            : "invoices"
          : invoicesCount.invalid.length === 1
          ? "order"
          : "orders";
        const message = `${invoicesCount.invalid.length} ${itemType} ${
          invoicesCount.invalid.length === 1 ? "is" : "are"
        } already present in existing loadout. These will be removed from the current loadout selection`;
        setGenericModalProps({
          type: "negative",
          message,
          leftButtonText: "Continue",
          open: true,
          onLeftButtonClick: () => updateCurrentLoadout(),
        });
      }
    }
  }, [invoicesCount]);

  useEffect(() => {
    const fetchLoadout = async () => {
      setFetchedLoadNumberWiseData(false);

      let lodaoutData = location?.state?.row;
      if (!lodaoutData || !lodaoutData?.loadOutDetails) {
        if (Object.keys(cart?.cartData?.loadoutData).length > 0) {
          lodaoutData = cart?.cartData?.loadoutData;
        } else {
          const apiResponse = await getSingleLoadout(loadNumber ?? "", true);
          if (apiResponse?.data?.content?.length === 0) {
            openPopUp(
              `Some error occurred while fetching data for loadout Number: ${loadNumber}`,
              "Error"
            );
            return;
          }
          lodaoutData = apiResponse?.data?.content[0];
        }
      }

      dispatch({ type: "SET_LOADOUT_DATA", payload: lodaoutData });

      if (lodaoutData.loadoutSource === "INVOICE") {
        dispatch({ type: "SET_SWITCH_STATE", payload: true });
      }

      setLoadoutStatus(lodaoutData.status);
      setLoadoutResponse(lodaoutData);
      setInvoicesCount((prev) => ({
        invalid: prev.invalid,
        valid: lodaoutData.loadOutDetails?.length,
      }));
      const setOfInvoiceNumbers = new Set<string>(
        lodaoutData?.loadOutDetails.map((detail: any) => detail.invoiceNumber)
      );
      setInvoiceNumbersSet(setOfInvoiceNumbers);

      if (lodaoutData?.deliveryStartDate && lodaoutData?.deliveryEndDate) {
        const start = dayjs(
          cart?.loadoutConfig?.enableDeliveryDateAssignment ||
            cart?.loadoutConfig?.dateFilter === "deliveryDate"
            ? lodaoutData?.deliveryStartDate
            : lodaoutData?.invoiceCreationStartDate
        );
        const end = dayjs(
          cart?.loadoutConfig?.enableDeliveryDateAssignment ||
            cart?.loadoutConfig?.dateFilter === "deliveryDate"
            ? lodaoutData?.deliveryEndDate
            : lodaoutData?.invoiceCreationEndDate
        );
        dateChangeHandler(start, end);
      } else {
        openPopUp(
          "Unable to fetch deliveryStartDate and deliveryStartDate fot thie loadout.",
          "Error"
        );
        return;
      }

      let salesRepData: string[] = [];
      await logLoadTrace(async () => {
        salesRepData = await setSalesRepDropdownData();
      }, "delivery_loadout_preseller_salesrep_or_delivery_route_load_time");

      setSelectedSalesman(lodaoutData?.salesmanId);

      const startDate = dayjs(
        cart?.loadoutConfig?.enableDeliveryDateAssignment ||
          cart?.loadoutConfig?.dateFilter === "deliveryDate"
          ? lodaoutData?.deliveryStartDate
          : lodaoutData?.invoiceCreationStartDate
      );
      const endDate = dayjs(
        cart?.loadoutConfig?.enableDeliveryDateAssignment ||
          cart?.loadoutConfig?.dateFilter === "deliveryDate"
          ? lodaoutData?.deliveryEndDate
          : lodaoutData?.invoiceCreationEndDate
      );

      await fetchData(
        startDate,
        endDate,
        cart?.loadoutConfig.dataDisplayPreference || [],
        lodaoutData.status,
        lodaoutData.loadoutSource === "INVOICE",
        lodaoutData,
        setOfInvoiceNumbers,
        salesRepData
      );

      setIsFetchDataComplete({
        fetchedCombinedData: true,
        fetchedCurrentData: false,
      });

      setFetchedLoadNumberWiseData(true);

      if (pageLoadTraceRef.current) {
        pageLoadTraceRef.current.stop();
        console.log(
          `view_or_edit_delivery_loadout_page_load_time log traced: ${
            (pageLoadTraceRef.current as any).durationUs / 1000
          } ms`
        );
        pageLoadTraceRef.current = null;
      }
    };

    if (loadNumber && isConfigLoaded) {
      fetchLoadout();
    }
  }, [location?.state, cart?.loadoutConfig, isConfigLoaded]);

  useEffect(() => {
    if (!apiStatus.orderStatus && !apiStatus.invoiceStatus) {
      setGenericModalProps(
        getGenericModalProps("error", "Unable to fetch order and invoice data.")
      );
    } else if (!apiStatus.orderStatus && !cart?.switchState) {
      setGenericModalProps(
        getGenericModalProps("error", "Unable to fetch order data.")
      );
    } else if (!apiStatus.invoiceStatus && cart?.switchState) {
      setGenericModalProps(
        getGenericModalProps("error", "Unable to fetch invoice data.")
      );
    }

    const updatedownloadReportConfig = async () => {
      if (!cart?.switchState) {
        const orderReportIdConfig = await getConfigData(
          "dms_configuration",
          "orderReportId"
        );
        const orderReportId = orderReportIdConfig[0]?.configValue ?? "";
        setDownloadSingleReportConfig(
          getDownloadSingleReportConfig(orderReportId)
        );
      } else {
        setDownloadSingleReportConfig(null);
      }
    };

    updatedownloadReportConfig();
    updateRowsAndColumns(combinedData, cart?.switchState, loadoutStatus);
  }, [cart?.switchState, combinedData, loadoutStatus]);

  useEffect(() => {
    const handleBeforeUnload = async () => {
      await insertDataIntoLocalDB("Cart", [{ id: 1, data: cart }]);
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [cart]);

  useEffect(() => {
    let finalData = currentData;
    if (
      searchVal.length > 1 ||
      selectedSalesrepOrRoute.length > 0 ||
      ((cart?.loadoutConfig?.enableDeliveryDateAssignment ||
        cart?.loadoutConfig?.dateFilter) &&
        (deliveryStartDate || deliveryEndDate))
    ) {
      finalData = searchedData(
        currentData,
        cart?.switchState,
        searchVal,
        selectedSalesrepOrRoute,
        deliveryStartDate,
        deliveryEndDate,
        cart?.loadoutConfig,
        outletRouteMap,
        selectedRoute
      );
    }

    const selectableIds = finalData.map((data) => data.id);
    setSelectableRowIds(selectableIds);

    if (
      (!loadNumber || loadoutStatus === "IN-DRAFT") &&
      selectedSalesrepOrRoute.length === 0 &&
      checkedIdArray.length > 0
    ) {
      setCheckedIdArray([]);
    }

    // Sort rows when loadoutStatus is IN-DRAFT
    if (loadoutStatus === "IN-DRAFT" || isCartDataLoaded) {
      finalData = [...finalData].sort((a, b) => {
        const isAChecked = checkedIdArray.includes(a.id);
        const isBChecked = checkedIdArray.includes(b.id);
        if (isAChecked && !isBChecked) return -1; // Checked rows first
        if (!isAChecked && isBChecked) return 1; // Unchecked rows after
        return 0; // Preserve relative order
      });
    }

    // Filter checked IDs when dates change and rows are updated
    if (shouldFilterCheckedIds && checkedIdArray.length > 0) {
      const validIds = new Set(finalData.map((row) => row.id));
      setCheckedIdArray((prev) => prev.filter((id) => validIds.has(id)));
      setShouldFilterCheckedIds(false);
    }
    setRows(finalData);
  }, [
    searchVal,
    currentData,
    cart?.switchState,
    selectedSalesrepOrRoute,
    deliveryStartDate,
    deliveryEndDate,
    isFetchDataComplete,
    outletRouteMap,
    cart?.loadoutConfig?.presellerRouteMaintained,
    shouldFilterCheckedIds,
  ]);

  useEffect(() => {
    if (
      cart?.loadoutConfig?.enableDeliveryRouteFilter &&
      deliveryRouteToSalesmanCodeMap.isLoaded &&
      salesRepDropdownDataRouteWise.isLoaded
    ) {
      const filteredDropdownData = Array.from(
        new Set(
          selectedRoute
            .map(
              (route) => deliveryRouteToSalesmanCodeMap.data.get(route) || []
            )
            .flat()
            .filter((loginId) =>
              salesRepDropdownDataRouteWise.data.some(
                (item) => item.split(" - ")[0] === loginId
              )
            )
            .map(
              (loginId) =>
                salesRepDropdownDataRouteWise.data.find(
                  (item) => item.split(" - ")[0] === loginId
                ) || loginId
            )
        )
      );
      setDropdownData((prev) => ({
        ...prev,
        allSalesRepOrRoute: filteredDropdownData,
      }));
      setSelectedSalesrepOrRoute((prev) => {
        const filteredSelectedSalesrepOrRoute = prev.filter((item) => {
          return filteredDropdownData.includes(item);
        });
        return filteredSelectedSalesrepOrRoute;
      });
    }
  }, [
    selectedRoute,
    isCartDataLoaded,
    salesRepDropdownDataRouteWise,
    deliveryRouteToSalesmanCodeMap,
  ]);

  useEffect(() => {
    if (
      loadNumber &&
      dropdownData.allSalesRepOrRoute.length > 0 &&
      !hasInitialMatchingDone
    ) {
      const uniquePresellerIdsFromLoadout: string[] = Array.from(
        new Set(
          loadoutResponse?.loadOutDetails
            .map((detail: any) => detail.presellerId)
            .filter((id: any): id is string => id !== null && id !== "")
        )
      );

      const matchedOptions = dropdownData.allSalesRepOrRoute.filter(
        (option) => {
          if (typeof option !== "string" || !option.includes(" - ")) {
            return false;
          }
          const optionId = option.split(" - ")[0];
          return uniquePresellerIdsFromLoadout.includes(optionId);
        }
      );

      if (matchedOptions.length > 0) {
        setSelectedSalesrepOrRoute(matchedOptions);
        setHasInitialMatchingDone(true);
      }
    }
  }, [
    loadNumber,
    loadoutStatus,
    dropdownData.allSalesRepOrRoute,
    selectedSalesrepOrRoute.length,
    isCartDataLoaded,
    hasInitialMatchingDone,
  ]);

  useEffect(() => {
    updateCheckedIds();
  }, [updateCheckedIds]);

  // Keyboard shortcut handler
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      // Check for Ctrl+S (Windows/Linux) or Cmd+S (Mac)
      if ((event.ctrlKey || event.metaKey) && event.key === "s") {
        event.preventDefault(); // Prevent browser's default save action

        // Only trigger if not currently loading and not in view mode
        if (!loader) {
          printLoadslip(
            loadNumber ?? "",
            cart,
            setSnackbarOpen,
            setIsDownloading,
            isDownloading,
            openPopUp,
            setSnackbarMessage,
            cart?.loadoutConfig?.loadSlipConfigs,
            selectedCheckboxes.map(
              (idx) => cart?.loadoutConfig?.loadslipMultipleFilters?.[idx]?.key
            )
          );
        }
      }
    };

    // Add event listener
    document.addEventListener("keydown", handleKeyDown);

    // Cleanup event listener on component unmount
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [loader, printLoadslip, selectedCheckboxes]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setDelayedLoading(
        (loadNumber && !fetchedLoadNumberWiseData) ||
          loader ||
          (!isCartDataLoaded && !isFetchDataComplete.fetchedCurrentData)
      );
    }, 100);

    return () => clearTimeout(timeout);
  }, [loadNumber, fetchedLoadNumberWiseData, loader, isFetchDataComplete]);

  const filters = useMemo(
    () =>
      cart?.loadoutConfig?.filtersConfig
        .filter((config) => config.key !== "deliveryDate")
        .sort((a, b) => a.order - b.order)
        .map((config) => {
          if (config.key === "salesRepOrRoute") {
            return {
              key: config.key,
              label: config.label,
              options: dropdownData.allSalesRepOrRoute,
              state: selectedSalesrepOrRoute,
              setState: setSelectedSalesrepOrRoute,
              isNecessary: config.isNecessary ?? true,
              multiSelect: config.multiSelect ?? true,
            };
          }
          if (
            config.key === "salesman" &&
            cart?.loadoutConfig.enableSalesmanAssignment
          ) {
            return {
              label: config.label,
              key: config.key,
              options: dropdownData.allSalesmans,
              state: selectedSalesman,
              setState: setSelectedSalesman,
              isNecessary: config.isNecessary ?? false,
              multiSelect: config.multiSelect ?? false,
            };
          }
          if (
            config.key === "vehicle" &&
            cart?.loadoutConfig.enableVehicleAssignment
          ) {
            return {
              label: config.label,
              key: config.key,
              options: dropdownData.allVehicles,
              state: selectedVehicle,
              setState: setSelectedVehicle,
              isNecessary: config.isNecessary ?? true,
              multiSelect: config.multiSelect ?? false,
            };
          }
          if (config.key === "deliveryRoute") {
            return {
              label: config.label,
              key: config.key,
              options: dropdownData.allDeliveryRoutes,
              state: selectedRoute,
              setState: setSelectedRoute,
              isNecessary: config.isNecessary ?? true,
              multiSelect: config.multiSelect ?? true,
            };
          }
          return null;
        })
        .filter(
          (filter): filter is NonNullable<typeof filter> => filter !== null
        ),
    [
      cart?.loadoutConfig.filtersConfig,
      cart?.loadoutConfig.enableSalesmanAssignment,
      cart?.loadoutConfig.enableVehicleAssignment,
      dropdownData.allSalesRepOrRoute,
      dropdownData.allSalesmans,
      dropdownData.allVehicles,
      dropdownData.allDeliveryRoutes,
      selectedSalesrepOrRoute,
      selectedSalesman,
      selectedVehicle,
      selectedRoute,
    ]
  );

  const handleRedirect = async (redirectUrl: string, rowData: any) => {
    if (!rowData) return;

    await insertDataIntoLocalDB("Cart", [
      {
        id: 1,
        data: {
          ...cart,
          cartData: {
            ...cart.cartData,
            loadout: {
              ...cart.cartData.loadout,
              salesRepOrRoute: selectedSalesrepOrRoute,
              selectedRoute: selectedRoute,
            },
          },
        },
      },
    ]);
    navigate(`${redirectUrl}${rowData.orderNumber}`);
  };

  const printLoadoutSlip = () => {
    setShowPopup(true);
  };

  return (
    <div
      style={{
        padding: "11px 15px 16px 15px",
        justifyContent: "space-between",
      }}
      className="manage_loadout_parent"
    >
      {showPopup ? (
        <CustomGenericModal
          type=""
          message={cart?.loadoutConfig?.loadslipMultipleFilters?.map(
            (config) => config.label
          )}
          modalOpen={showPopup}
          onClose={() => {
            setShowPopup(false);
            setSelectedCheckboxes([]);
          }}
          errorMessages={false}
          addCheckBox={true}
          selectedCheckboxes={selectedCheckboxes}
          errorMessageText={errorMessageText}
          setSelectedCheckboxes={(selectedCheckboxes: number[]) => {
            setSelectedCheckboxes(selectedCheckboxes);
            setErrorMessageText("");
          }}
          headerText="Print Loadslip"
          subHeaderText="Select the Loadslip format you want to print"
          headerIcon={{
            headerIconType: "print",
            width: "100%",
          }}
          leftButtonText="Print"
          onLeftButtonClick={() => {
            if (selectedCheckboxes.length === 0) {
              setErrorMessageText(
                "Please select at least one format to download the Loadout Slip."
              );
              return;
            } else {
              setErrorMessageText("");
            }
            printLoadslip(
              loadNumber ?? "",
              cart,
              setSnackbarOpen,
              setIsDownloading,
              isDownloading,
              openPopUp,
              setSnackbarMessage,
              cart?.loadoutConfig?.loadSlipConfigs,
              selectedCheckboxes.map(
                (idx) =>
                  cart?.loadoutConfig?.loadslipMultipleFilters?.[idx]?.key
              )
            );
          }}
        />
      ) : genericModalProps?.open ? (
        <CustomGenericModal
          type={genericModalProps?.type}
          message={genericModalProps?.message}
          leftButtonText={genericModalProps?.leftButtonText}
          rightButtonText={genericModalProps?.rightButtonText}
          modalOpen={genericModalProps?.open}
          onLeftButtonClick={genericModalProps?.onLeftButtonClick}
          onRightButtonClick={genericModalProps?.onRightButtonClick}
          onClose={
            invoicesCount?.invalid?.length > 0
              ? undefined
              : () => {
                  setGenericModalProps(initialGenericModalProps);
                }
          }
        />
      ) : null}
      <GenericPopUp
        message={genericMessage}
        type={popupType}
        openGenericModal={openGenericModal}
        setOpenGenericModal={setOpenGenericModal}
        onCloseCallback={
          loadNumber ||
          cart?.loadoutConfig?.gapBetweenCreationAndDeliveryDate < 0
            ? () => {
                navigate("/dashboard/delivery/loadouts");
              }
            : undefined
        }
      />
      <Snackbar
        open={snackbarOpen}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        autoHideDuration={5000}
        onClose={handleSnackbarClose}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity="info"
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbarMessage
            ? snackbarMessage
            : "Your report will be downloaded shortly."}
        </Alert>
      </Snackbar>
      <Box sx={{ marginBottom: "10px" }}>
        <FormHeader
          parentLabel={"Loadout"}
          label={loadNumber ? loadNumber : "Create New Loadout"}
          goBackToParent={() => {
            navigate("/dashboard/delivery/loadouts");
            dispatch({ type: "RESET_PRESELLER_LOADOUT" });
          }}
          searchFunction={setSearchVal}
        />
      </Box>
      <LoadoutFilter
        filters={filters}
        deliveryStartDate={deliveryStartDate}
        deliveryEndDate={deliveryEndDate}
        loadoutConfig={cart?.loadoutConfig}
        dateChangeHandler={dateChangeHandler}
        loadoutStatus={loadoutStatus ?? ""}
        setSnackbarMessage={setSnackbarMessage}
        setSnackbarOpen={setSnackbarOpen}
      />
      {cart?.loadoutConfig.displayPresellerSummary &&
        cart?.loadoutConfig.enableVehicleAssignment && (
          <CreateSummaryCard
            title="Loadout Summary"
            box={
              selectedVehicle
                ? [
                    selectedVehicle,
                    consumedVehicleCapacity ?? dummyVehicleOption,
                    {
                      ...dummyVehicleOption,
                      vehicleCapacityKG:
                        (selectedVehicle?.vehicleCapacityKG ?? 0) -
                        (consumedVehicleCapacity?.vehicleCapacityKG ?? 0),
                      vehicleCapacityCubicFeet:
                        (selectedVehicle?.vehicleCapacityCubicFeet ?? 0) -
                        (consumedVehicleCapacity?.vehicleCapacityCubicFeet ??
                          0),
                    },
                  ]
                : [dummyVehicleOption, dummyVehicleOption, dummyVehicleOption]
            }
          />
        )}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          justifyContent: "flex-end",
        }}
      >
        {selectedSalesrepOrRoute.length > 0 &&
          (!cart?.loadoutConfig.enableSalesmanAssignment ||
            !cart?.loadoutConfig?.filtersConfig?.find(
              (config) => config.key === "salesman"
            )?.isNecessary ||
            selectedSalesman) &&
          (!cart?.loadoutConfig.enableVehicleAssignment ||
            !cart?.loadoutConfig?.filtersConfig?.find(
              (config) => config.key === "vehicle"
            )?.isNecessary ||
            selectedVehicle) &&
          (!cart?.loadoutConfig.enableDeliveryDateAssignment ||
            !cart?.loadoutConfig?.dateFilter) &&
          deliveryStartDate &&
          deliveryEndDate &&
          cart?.loadoutConfig?.dataDisplayPreference?.every(
            (item) => item.visible === true
          ) &&
          !loadNumber && (
            <Box sx={{ display: "flex", mt: "10px" }}>
              <Typography
                sx={{
                  fontWeight: !cart?.switchState ? "600" : "",
                  color: !cart?.switchState ? "#252525" : "#7C7C7C",
                  fontSize: "14px",
                  mr: "5px",
                  letterSpacing: 0,
                }}
              >
                Order no. wise
              </Typography>
              <ReactSwitch
                checked={cart?.switchState}
                onChange={() => {
                  logAnalyticsEvent(
                    "delivery_loadout_preseller_order_or_invoice",
                    {
                      distributor_id: JSON.parse(localStorage.authContext).user
                        .loginId,
                      loadout_start_date_selected: cart?.switchState
                        ? "ORDER"
                        : "INVOICE",
                    }
                  );
                  dispatch({ type: "TOGGLE_SWITCH_STATE" });
                }}
                offColor="#00C6B1"
                onColor="#00C6B1"
                handleDiameter={13.2}
                uncheckedIcon={false}
                checkedIcon={false}
                height={20.7}
                width={42.6}
              />
              <Typography
                sx={{
                  fontWeight: cart?.switchState ? "600" : "",
                  color: cart?.switchState ? "#252525" : "#7C7C7C",
                  fontSize: "14px",
                  ml: "5px",
                  letterSpacing: 0,
                }}
              >
                Invoice no. wise
              </Typography>
            </Box>
          )}

        {!loadNumber &&
        (selectedSalesrepOrRoute.length === 0 ||
          (cart?.loadoutConfig.enableSalesmanAssignment &&
            cart?.loadoutConfig?.filtersConfig?.find(
              (config) => config.key === "salesman"
            )?.isNecessary &&
            !selectedSalesman) ||
          (cart?.loadoutConfig.enableVehicleAssignment &&
            cart?.loadoutConfig?.filtersConfig?.find(
              (config) => config.key === "vehicle"
            )?.isNecessary &&
            !selectedVehicle) ||
          ((cart?.loadoutConfig.enableDeliveryDateAssignment ||
            cart?.loadoutConfig?.dateFilter) &&
            (!deliveryStartDate || !deliveryEndDate))) ? (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
            }}
          >
            <img
              src={selectOptionFirst}
              alt="Select Option First"
              style={{ objectFit: "cover", marginBottom: "17px" }}
            />
            <Typography sx={{ color: "484848" }}>
              {`Please select ${cart?.loadoutConfig?.filtersConfig
                ?.filter((config) => config.isNecessary)
                .map((config, idx, arr) => {
                  // Use label or fallback to key
                  const label = config.label || config.key;
                  // Add "and" before the last item if more than one
                  if (arr.length > 1 && idx === arr.length - 1) {
                    return `and ${label}`;
                  }
                  return label;
                })
                .join(
                  cart?.loadoutConfig?.filtersConfig?.length > 2 ? ", " : " "
                )} to create loadout`}
            </Typography>
          </div>
        ) : delayedLoading ? (
          <Loader sx={{ position: "absolute", top: "55%" }} />
        ) : (
          <CustomDataGrid
            rows={rows}
            columnsMetaData={
              cart?.loadoutConfig.presellerRouteMaintained ||
              cart?.loadoutConfig.enableDeliveryRouteFilter
                ? columnsMetaData
                : {
                    ...columnsMetaData,
                    columns: columnsMetaData.columns.filter(
                      (column: any) => column?.headerName !== "Route ID & Name"
                    ),
                  }
            }
            tableWidth={
              columnsMetaData.Actions.includes("view") &&
              columnsMetaData.Actions.includes("download")
                ? 0.723
                : columnsMetaData.Actions.includes("view") ||
                  columnsMetaData.Actions.includes("download")
                ? 0.76
                : 0.8
            }
            redirectUrlFunction={handleRedirect}
            downloadSingleReportConfig={downloadSingleReportConfig}
            isCheckboxSelection={
              loadoutStatus === "IN-TRANSIT" || loadoutStatus === "DELIVERED"
                ? false
                : true
            }
            checkedIdArray={checkedIdArray}
            setCheckedIdArray={(ids: any) => updateCheckedIdArray(ids)}
            redirectUrl={
              cart?.switchState
                ? loadNumber
                  ? `/dashboard/delivery/loadouts/preseller/viewLoadout/${loadNumber}/`
                  : "/dashboard/delivery/loadouts/preseller/"
                : "/dashboard/sale/manageOrders/viewOrder/"
            }
            onDownloadGeneric={
              cart?.switchState ? onInvoiceDownLoad : undefined
            }
          />
        )}

        <div style={{ height: "auto" }}>
          <LoadoutCartSummaryFooter
            totalAmountAndQtyInfo={{
              numberOfProducts: Object.keys(cart?.cartData?.product ?? {})
                .length,
              totalCaseQuantity: cart?.totals?.totalCase,
              totalPieceQuantity: cart?.totals?.totalPiece,
              totalOtherUnitQuantity: cart?.totals?.totalOther,
              totalAmount: cart?.totals?.totalAmount,
            }}
            cartProducts={cart?.cartData?.product}
            displayDeleteButton={loadoutStatus === "IN-DRAFT"}
            onButtonClick={() => {
              if (
                loadNumber &&
                (loadoutStatus === "IN-TRANSIT" ||
                  loadoutStatus === "DELIVERED")
              ) {
                cart?.loadoutConfig?.loadslipMultipleFilters?.length > 0
                  ? printLoadoutSlip()
                  : printLoadslip(
                      loadNumber ?? "",
                      cart,
                      setSnackbarOpen,
                      setIsDownloading,
                      isDownloading,
                      openPopUp,
                      setSnackbarMessage,
                      cart?.loadoutConfig?.loadSlipConfigs,
                      selectedCheckboxes.map(
                        (idx) =>
                          cart?.loadoutConfig?.loadslipMultipleFilters?.[idx]
                            ?.key
                      )
                    );
              } else {
                handleReviewLoadout();
              }
            }}
            onDeleteButtonClick={handleDelete}
            buttonText={
              loadNumber &&
              (loadoutStatus === "IN-TRANSIT" || loadoutStatus === "DELIVERED")
                ? "Print Loadslip"
                : !loadNumber || (loadNumber && loadoutStatus === "IN-DRAFT")
                ? "Review Loadout"
                : ""
            }
            disabled={
              !isFetchDataComplete.fetchedCurrentData ||
              checkedIdArray.length === 0 ||
              (cart?.loadoutConfig?.enableVehicleAssignment &&
                cart?.loadoutConfig?.enableVehicleCapacityValidation &&
                (consumedVehicleCapacity?.vehicleCapacityCubicFeet ?? 0) >
                  (selectedVehicle?.vehicleCapacityCubicFeet ?? 0)) ||
              (cart?.loadoutConfig?.enableVehicleAssignment &&
                cart?.loadoutConfig?.enableVehicleCapacityValidation &&
                (consumedVehicleCapacity?.vehicleCapacityKG ?? 0) >
                  (selectedVehicle?.vehicleCapacityKG ?? 0))
            }
            reviewLoadout={false}
            endIcon={
              loadNumber &&
              (loadoutStatus === "IN-TRANSIT" || loadoutStatus === "DELIVERED")
                ? false
                : true
            }
          />
        </div>
      </div>
    </div>
  );
}
